import { render } from "./UpcomingAppointmentCard.vue?vue&type=template&id=099d8ec9&scoped=true"
import script from "./UpcomingAppointmentCard.vue?vue&type=script&lang=js"
export * from "./UpcomingAppointmentCard.vue?vue&type=script&lang=js"

import "./UpcomingAppointmentCard.vue?vue&type=style&index=0&id=099d8ec9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-099d8ec9"]])

export default __exports__